import { render, staticRenderFns } from "./TopSonResultDetails.vue?vue&type=template&id=21b7453b&scoped=true"
import script from "./TopSonResultDetails.vue?vue&type=script&lang=js"
export * from "./TopSonResultDetails.vue?vue&type=script&lang=js"
import style0 from "./TopSonResultDetails.vue?vue&type=style&index=0&id=21b7453b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b7453b",
  null
  
)

export default component.exports